import axios from "../../axios-auth";
import router from "../../router";
import Vue from "vue";

const state = {
  doctors: [],
  doctor: null,
  unassignedDoctors: [],
  assignedDoctors: [],
  eventDoctor: null,
};

const mutations = {
  SET_UNASSIGNED_DOCTORS(state, payload) {
    state.unassignedDoctors = payload;
  },
  SET_ASSIGNED_DOCTORS(state, payload) {
    state.assignedDoctors = payload;
  },
  SET_DOCTOR(state, payload) {
    state.doctor = payload;
  },
  SET_EVENT_DOCTOR(state, payload) {
    state.eventDoctor = payload;
  },
};

const actions = {
  async saveDoctor({ commit, state, dispatch, rootGetters }, payload) {
    axios
      .post("/doctors", payload.data.doctor, {
        headers: {
          Authorization: "Bearer " + rootGetters.token,
        },
      })
      .then((res) => {
        const msg = "You successfully saved a new doctor";
        const toast = {
          vm: payload.vm,
          msg: msg,
          color: "success",
        };
        // payload.vm.resetFields();
        payload.vm.loading = false;
        commit("makeToast", toast);
        if (payload.data.byEvent) {
          commit("SET_DOCTOR", res.data);

          const doctorData = {
            id: res.data.id,
          };
          dispatch("assigDoctorToEvent", {
            doctorData,
            eventId: router.currentRoute.params.id,
          }).then((data) => {
            const event = payload.event;

            if (event.hasPrintForm && !data.formPrinted) {
              router.push({
                name: "Print Form",
                params: {
                  eventId: router.currentRoute.params.id,
                  id: state.doctor.id,
                },
              });
            } else if (event.hasQuestionnaire && !data.questionnaireSubmitted) {
              router.push({
                name: "Questionnaire",
                params: {
                  eventId: router.currentRoute.params.id,
                  doctorId: state.doctor.id,
                },
              });
            } else if (event.hasPhoto && !data.photoPrinted) {
              router.push({
                name: "Select Frame",
                params: {
                  doctorId: state.doctor.id,
                  eventId: router.currentRoute.params.id,
                },
              });
            } else if (event.hasVoucher && !data.voucherPrinted) {
              payload.vm.$bvModal.show("voucher-modal");
            } else {
              router.push({ name: "Thank You" });
            }
          });
        }
      })
      .catch((err) => {
        // console.log("ERRDD", err);
        const msg = "There was an error saving your doctor";
        payload.vm.loading = false;
        const toast = {
          vm: payload.vm,
          msg: msg,
          color: "danger",
        };

        commit("makeToast", toast);
      });
  },
  async assigDoctorToEvent({ commit, dispatch, rootGetters }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("/events/" + payload.eventId + "/doctors", payload.doctorData, {
          headers: { Authorization: "Bearer " + rootGetters.token },
        })
        .then((res) => {
          commit("SET_EVENT_DOCTOR", res.data);
          dispatch("getUnassignedDoctors", { eventId: payload.eventId });
          dispatch("getAssignedDoctors", { eventId: payload.eventId });
          dispatch(
            "doctorExistInEvent",
            {
              eventId: payload.eventId,
              doctorId: payload.doctorData.id,
            },
            { root: true }
          );
          resolve(res.data);
        })
        .catch((err) => {});
    });
  },
  getUnassignedDoctors({ commit, dispatch, rootGetters }, payload) {
    axios
      .get("/doctors", {
        headers: { Authorization: "Bearer " + rootGetters.token },
      })
      .then((res1) => {
        axios
          .get("/events/" + payload.eventId + "/doctors/assigned", {
            headers: { Authorization: "Bearer " + rootGetters.token },
          })
          .then((res2) => {
            const assigned = res2.data;
            const doctors = res1.data;

            let result = doctors.filter(
              (o1) => !assigned.some((o2) => o1.id === o2.doctorId)
            );

            commit("SET_UNASSIGNED_DOCTORS", result);
          })
          .catch((err) => {});
      })
      .catch((err) => {});
  },
  getAssignedDoctors({ commit, rootGetters }, payload) {
    axios
      .get("/events/" + payload.eventId + "/doctors/assigned", {
        headers: { Authorization: "Bearer " + rootGetters.token },
      })
      .then((res) => {
        let assignedDoctors = res.data;
        if (Object.prototype.hasOwnProperty.call(payload, "report")) {
          assignedDoctors.unshift({ name: "Select All", doctorId: "all" });
        }
        commit("SET_ASSIGNED_DOCTORS", assignedDoctors);
      })
      .catch((err) => {});
  },
  getDoctors({ commit, rootGetters }) {
    axios
      .get("/doctors", {
        headers: { Authorization: "Bearer " + rootGetters.token },
      })
      .then((res) => commit("SET_DOCTORS", res.data))
      .catch((err) => {});
  },
  getDoctor({ commit, rootGetters }, payload) {
    axios
      .get("/doctors/" + payload.id, {
        headers: {
          Authorization: "Bearer " + rootGetters.token,
        },
      })
      .then((res) => {
        commit("SET_DOCTOR", res.data);
      })
      .catch((err) => {});
  },
  sendOtp({ commit, rootGetters }, payload) {
    axios
      .post(
        "/sms",
        { phoneNumber: "+2" + payload.phoneNumber },
        { headers: { Authorization: "Bearer " + rootGetters.token } }
      )
      .then((res) => {
        payload.vm.$bvModal.show("verfication-modal");
      })
      .catch((err) => {
        const msg = "There was an error sending the OTP";
        payload.vm.loading = false;
        const toast = {
          vm: payload.vm,
          msg: msg,
          color: "danger",
        };

        commit("makeToast", toast);
      });
  },
  verifyOtp({ commit, dispatch, state, rootGetters }, payload) {
    // console.log("PAYLOAD", payload);
    axios
      .post("/sms/verify-otp", payload.data, {
        headers: { Authorization: "Bearer " + rootGetters.token },
      })
      .then((res) => {
        payload.vm.$bvModal.hide("verfication-modal");
        const msg = "You successfully verified this phone number";
        const toast = {
          vm: payload.vm,
          msg: msg,
          color: "success",
        };
        payload.vm.resetFields();
        commit("makeToast", toast);
      })
      .then(() => {
        state.doctor.verified = true;
        dispatch("saveDoctor", {
          vm: payload.vm,
          event: payload.event,
          data: {
            doctor: state.doctor,
            byEvent: true,
            eventId: router.currentRoute.params.id,
          },
        });
      })
      .catch((err) => {
        const msg = "The Verification code might be incorrect";
        payload.vm.loading = false;
        const toast = {
          vm: payload.vm,
          msg: msg,
          color: "danger",
        };

        commit("makeToast", toast);
      });
  },
  getDoctorByMobileNumber({ commit, rootGetters }, payload) {
    axios
      .post(
        "/doctors/findByMobile",
        { mobileNo: payload.mobileNo },
        {
          headers: { Authorization: "Bearer " + rootGetters.token },
        }
      )
      .then((res) => {
        commit("SET_DOCTOR", res.data);
      })
      .catch((err) => {});
  },
  checkDoctorByMobileNumber({ commit, dispatch, rootGetters }, payload) {
    axios
      .post(
        "/doctors/check-mobile",
        { mobileNo: payload.mobileNo },
        {
          headers: { Authorization: "Bearer " + rootGetters.token },
        }
      )
      .then((res) => {
        if (payload.addDoctor) {
          dispatch("sendOtp", {
            phoneNumber: payload.mobileNo,
            vm: payload.vm,
          });
        }
      })
      .catch((err) => {
        const msg = err.response.data.message;
        payload.vm.loading = false;
        const toast = {
          vm: payload.vm,
          msg: msg,
          color: "danger",
        };

        commit("makeToast", toast);
      });
  },
};

const getters = {
  doctor(state) {
    return state.doctor;
  },
  doctors(state) {
    return state.doctors;
  },
  unassignedDoctors(state) {
    return state.unassignedDoctors;
  },
  assignedDoctors(state) {
    return state.assignedDoctors;
  },
  eventDoctor(state) {
    return state.eventDoctor;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
